(() => {
  const LOG = (...a) => console.log('%c[ADD-ONS]', 'color:#6b4eff', ...a);
  // LOG('script loaded');

  function initAddons(root) {
    const addonCards = [...root.querySelectorAll('[data-addon]')];
    if (!addonCards.length) return;

    // Find the closest product form for this block
    const productForm =
      root.closest('section')?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const addToCartBtn = productForm?.querySelector('[type="submit"]');

    if (!productForm || !addToCartBtn) return;

    let isAdding = false;

    const setCardUI = (card, checked) => {
      card.classList.toggle('addon-selected', checked);
      const cb = card.querySelector('.addon-checkbox');
      if (cb) cb.checked = checked;
    };

    addonCards.forEach(card => {
      const cb = card.querySelector('.addon-checkbox');
      if (!cb) return;

      card.addEventListener('click', e => {
        // Don't toggle when user clicks the "Ver Produto" link (or any link)
        if (e.target.closest('a')) return;

        // Toggle always
        cb.checked = !cb.checked;
        setCardUI(card, cb.checked);
      });

      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          cb.checked = !cb.checked;
          setCardUI(card, cb.checked);
        }
      });

      cb.addEventListener('change', () => setCardUI(card, cb.checked));
    });

    async function fetchCart() {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return r.json();
    }

    async function syncFromCart() {
      const cart = await fetchCart();
      const ids = new Set(cart.items.map(i => Number(i.variant_id)));
      addonCards.forEach(card => setCardUI(card, ids.has(Number(card.dataset.variantId))));
      return cart;
    }

    syncFromCart().catch(() => {});

    // Kill native submit (Horizon has multiple handlers)
    productForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    function getPackQty() {
      // Find pack selector near this form (same section), fallback to global
      const packRoot =
        productForm.closest('section')?.querySelector('[data-memo-pack]') ||
        document.querySelector('[data-memo-pack]');

      const packRadio = packRoot?.querySelector('input[name="memo_pack_choice"]:checked');
      return Math.max(1, parseInt(packRadio?.value || '1', 10));
    }

    function ensureQtyInput(qty) {
      let qtyInput = productForm.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        productForm.appendChild(qtyInput);
      }
      qtyInput.value = String(qty);

      // expose (optional, useful for other scripts)
      productForm.dataset.memoraPackQty = String(qty);
      window.MEMORA_PACK_QTY = qty;
    }

    // Own the click
    addToCartBtn.addEventListener('click', async e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (isAdding) return;
      isAdding = true;

      try {
        const packQty = getPackQty();
        ensureQtyInput(packQty);

        // Build FormData AFTER quantity is ensured
        const fd = new FormData(productForm);
        const mainVariantId = Number(fd.get('id'));

        if (!mainVariantId) throw new Error('Variante principal não encontrada.');

        const items = [{ id: mainVariantId, quantity: packQty }];

        addonCards.forEach(card => {
          const cb = card.querySelector('.addon-checkbox');
          if (!cb || !cb.checked) return;

          // "pack" = scales with packQty, "order" = always 1
          const multMode = (card.dataset.addonMult || 'pack').toLowerCase();
          const addonQty = multMode === 'order' ? 1 : packQty;

          items.push({ id: Number(card.dataset.variantId), quantity: addonQty });
        });

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err?.description || 'Erro ao adicionar ao carrinho');
        }

        const cart = await fetchCart();

        // Horizon listens to cart:update
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'custom-addons',
            data: { source: 'custom-addons', itemCount: cart.item_count, didError: false }
          }
        }));

        // Open drawer (lazy)
        const tryOpenDrawer = () => {
          const drawer =
            document.querySelector('cart-drawer-component') ||
            document.querySelector('cart-drawer');
          if (drawer?.open) { drawer.open(); return true; }
          return false;
        };

        if (!tryOpenDrawer()) {
          document.querySelector('cart-icon')?.click();
          let tries = 0;
          const t = setInterval(() => {
            tries++;
            if (tryOpenDrawer() || tries >= 10) clearInterval(t);
          }, 120);
        }

        await syncFromCart();
      } catch (err) {
        console.error('[ADD-ONS] ERROR', err);
        alert(err.message || 'Erro ao adicionar ao carrinho');
      } finally {
        isAdding = false;
      }
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-product-addons]').forEach(initAddons);
  }

  document.addEventListener('DOMContentLoaded', boot);

  // Shopify theme editor (prevents “works on refresh but not in editor”)
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
